

<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>管理訂單</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <vs-select v-model="dataOrder_status" label="訂單狀態" class="mt-5 w-full">
          <vs-select-item
            :key="item.value"
            :value="item.value"
            :text="item.text"
            v-for="item in order_status_choices"
          />
        </vs-select>

        <vs-select v-model="dataDeliverer" label="車手" class="mt-5 w-full">
          <vs-select-item
            :key="item.value"
            :value="item.value"
            :text="item.text+'('+item.value+')'"
            v-for="item in delivererList"
          />
        </vs-select>

        <vs-input label="內部備註" v-model="dataRemarksInt" class="mt-5 w-full" name="item-name" />
        <span
          class="text-danger text-sm"
          v-show="errors.has('item-name')"
        >{{ errors.first('item-name') }}</span>

        <vs-input
          icon-pack="feather"
          icon="icon-dollar-sign"
          label="價錢"
          v-model="dataPrice"
          class="mt-5 w-full"
          v-validate="{ required: true, regex: /\d+(\.\d+)?$/ }"
          name="item-price"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('item-price')"
        >{{ errors.first('item-price') }}</span>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">提交</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">取消</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        let {
          id,
          orderId,
          remarksInt,
          orderStatus,
          orderAmount,
          deliverer,
          orderPhone,
          orderPerson,
          orderLang
        } = JSON.parse(JSON.stringify(this.data));

        this.id = id;
        this.dataId = orderId;
        this.dataRemarksInt = remarksInt == null ? "" : remarksInt;
        this.dataDeliverer = deliverer;
        this.dataOrder_status = orderStatus;
        this.dataPrice = orderAmount;
        this.dataCustPhone = orderPhone;
        this.dataOrderPerson = orderPerson;
        this.datalang = orderLang;
        this.initValues();
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  data() {
    return {
      dataId: null,
      dataRemarks: "",
      dataRemarksInt: "",
      dataOrder_status: "",
      dataDeliverer: "",
      dataCustPhone: "",
      dataPrice: 0,
      delivererList: [
        { text: "Abe", value: "93206366" },
        { text: "Max", value: "55963321" },
        { text: "Ken", value: "93096608" },
        { text: "耀裕", value: "44029499" },
        { text: "蘭", value: "69969654" },
        { text: "Tszling", value: "60200166" },
        { text: "Vivi", value: "92487871" },
        { text: "May", value: "56800683" },
        { text: "Pan", value: "93781129" },
        { text: "日", value: "64626286" },
        { text: "Hailey", value: "96084925" },
        { text: "Ming", value: "62340126" },
        { text: "Joe", value: "62045449" },
        { text: "阿肥", value: "93111346"},
        { text: "樂", value: "46757572"},
        { text: "Hotwing", value: "51333551"},
        { text: "昇", value: "98463918"},
        { text: "朱", value: "92073476"}
      ],
      order_status_choices: [
        { text: "待付款", value: "WP" },
        { text: "準備中", value: "P" },
        { text: "運送中", value: "S" },
        { text: "已完成", value: "C" },
        { text: "已取消", value: "X" }
      ],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    },
    isFormValid() {
      return true;
    }
  },
  methods: {
    initValues() {
      if (this.data.id) return;
      this.dataId = null;
      (this.dataRemarksInt = ""), (this.dataDeliverer = "");
      this.dataOrder_status = "";
      this.dataPrice = 0;
    },
    submitData() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            firebaseId: this.id,
            orderId: this.dataId,
            order_status: this.dataOrder_status,
            price: this.dataPrice,
            deliverer: this.dataDeliverer,
            remarksInt: this.dataRemarksInt,
            orderLang: this.datalang
          };
          if (obj.firebaseId !== null && obj.firebaseId != "") {
            this.$store.dispatch("updateOrderInfoAdmin", obj).then(() => {
              this.statusUpdate(obj);
            });
          } else {
            //this.$store.dispatch("dataList/addItem", obj).catch(err => { console.error(err) })
          }

          this.$emit("closeSidebar");
          this.initValues();
        }
      });
    },

    getOrderStatus(status) {
      if (status == "S") return "運送中(Delivering)";
      if (status == "WP") return "待付款(Pending Payment)";
      if (status == "X") return "已取消(Cancelled)";
      if (status == "P") return "準備中(Pending)";
      return "已完成(Completed)";
    },
    statusUpdate(data) {
      if (data.order_status == "S") {
        var deliverStr = this.delivererList.filter(
          c => c.value.indexOf(this.dataDeliverer) > -1
        );
        if (deliverStr.length > 0) {
          window.open(
            "https://api.whatsapp.com/send?phone=852" +
              this.dataCustPhone +
              "&text=*****火紅蟻外賣平台*****%0a%0a訂單:"+
              "%0aOrder: " +
              data.orderId.replace("#", "") +
              "%0a%0a訂單進度更新: " +
              "%0aOrder Update: "+
              this.getOrderStatus(data.order_status) +
              "%0a%0a為你服務的送餐員:" +
              "%0aYour food is ready, Delivery man is delivering to you now: "+
              data.deliverer +
              "(" +
              deliverStr[0].text +
              ")",
            "_blank"
          );
        }
      }
      if (data.order_status == "C") {
          window.open(
            "https://api.whatsapp.com/send?phone=852" +
              this.dataCustPhone +
              "&text=*****火紅蟻外賣平台*****%0a%0a訂單:" +
              "%0aOrder: "+
              data.orderId.replace("#", "") +
              "%0a%0a已完成送餐%0a火紅蟻期待下次為你送餐"+
              "%0aThank you for your supporting! We are looking forward to seeing you use RED ANT FOOD again.",
            "_blank"
          );
      }
      if (data.order_status == "P") {
          window.open(
            "https://api.whatsapp.com/send?phone=852" +
              this.dataCustPhone +
              "&text=*****火紅蟻外賣平台*****%0a%0a訂單:" +
              "%0aOrder:" +
              data.orderId.replace("#", "") +
              "%0a%0a訂單進度更新: " +
              "%0aOrder Update: "+
              this.getOrderStatus(data.order_status) +
              "%0a%0a我們已經收到款項了，謝謝！%0aThe payment has been received, thank you!%0a%0a火紅蟻正在為你準備食物, 請耐心等候。"+
              "%0a Your order is coming soon, we will inform you at once as we get the news.",
            "_blank"
          );
      }
      if (data.order_status == "X") {
          window.open(
            "https://api.whatsapp.com/send?phone=852" +
              this.dataCustPhone +
              "&text=*****火紅蟻外賣平台*****%0a%0a訂單:" +
              data.orderId.replace("#", "") +
              "%0a%0a訂單已取消%0aYour order cancelled%0a%0a火紅蟻期待下次為你送餐%0aRedantfood is looking forward to serving you again",
            "_blank"
          );
      }
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader();
        reader.onload = e => {
          this.dataImg = e.target.result;
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    }
  },
  components: {
    VuePerfectScrollbar
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
